import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Over +100 customers have already ordered safely with us',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Over +1,000 customers have already ordered safely with us',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Over +10,000 customers have already ordered safely with us',
  },
};
